import { isOpenQuoteAndOrderCalendarModal } from "@/atoms/is-open-quote-and-order-calendar-modal";
import { quoteAndOrderDurationState } from "@/atoms/quote-and-order-duration-state";
import { ButtonColor } from "@/common/enum/button-color";
import { calculateDateRange } from "@/common/util/date-util";
import { DateRange } from "@/types/date-range";
import { Button } from "flowbite-react";
import { useRecoilState } from "recoil";

export const PartnerQuoteDurationButtonGroup = () => {
  const [selectedDuration, setSelectedDuration] = useRecoilState(
    quoteAndOrderDurationState
  );
  const [modal, setModal] = useRecoilState(isOpenQuoteAndOrderCalendarModal);

  const durations = [
    { label: "이번달", value: 1 },
    { label: "3개월", value: 3 },
    { label: "6개월", value: 6 },
  ];

  const isSelected = (value: number) => {
    const { startDate, endDate } = calculateDateRange(value);
    return (
      selectedDuration.startDate?.toISOString() === startDate.toISOString() &&
      selectedDuration.endDate?.toISOString() === endDate.toISOString()
    );
  };

  const updateSelectedDuration = (duration: DateRange) => {
    if (duration.startDate) {
      setModal({ ...modal, startDate: undefined, endDate: undefined });
    }
    setSelectedDuration(duration);
  };

  const handleClick = (value: number) => {
    if (isSelected(value)) {
      updateSelectedDuration({ startDate: undefined, endDate: undefined });
    } else {
      updateSelectedDuration(calculateDateRange(value));
    }
  };

  return (
    <Button.Group>
      {durations.map((duration) => (
        <Button
          key={duration.value}
          color={
            isSelected(duration.value)
              ? ButtonColor.CUSTOM_GRAY
              : ButtonColor.ORIGIN_GRAY
          }
          onClick={() => handleClick(duration.value)}
        >
          {duration.label}
        </Button>
      ))}
    </Button.Group>
  );
};
